<script setup lang="ts">
import Check from '@/assets/icon-check.svg?component'

const submitSucceeded = ref(false)
const submit = (data: boolean) => {
  submitSucceeded.value = data
}
definePageMeta({
  middleware: 'auth',
  auth: false
})
useHead({
  titleTemplate: 'Przypomnij hasło - %s',
  meta: [
    { name: 'robots', content: 'index,follow' }
  ]
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name: 'Przypominanie hasła' }]" />
    <div v-if="$route.query.hash" class="flex justify-center my-[30px]">
      <div v-if="submitSucceeded" class="w-full md:w-1/3">
        <h2 class="text-32 font-bold">
          Zmieniłeś/aś hasło!
        </h2>
        <span class="text-16">Przejdź na stronę logowania.</span>
      </div>
      <div v-else class="w-full md:w-1/3">
        <h2 class="text-32 font-bold">
          Zmiana hasła
        </h2>
        <span class="text-16">Wprowadź nowe hasło.</span>
        <UserRecoveryPasswordConfirmForm />
      </div>
    </div>
    <div v-else class="flex justify-center my-[30px]">
      <div v-if="submitSucceeded" class="w-full md:w-2/3">
        <div class="flex items-center gap-[20px] bg-action text-white p-[15px]">
          <Check />
          <span>Na podany adres e-mail został wysłany link z możliwością zmiany hasła. Sprawdź swoją skrzynkę e-mail.</span>
        </div>
      </div>
      <div v-else class="w-full md:w-1/3">
        <h2 class="text-32 font-bold mb-[15px]">
          Zapomniałeś/aś hasła?
        </h2>
        <span class="text-16">Na podany e-mail wyślemy Ci link z możliwością zmiany hasła.</span>
        <UserRecoveryPasswordForm v-on:submit="submit" />
      </div>
    </div>
    <div class="flex justify-center">
      <div :class="{ 'md:w-1/3': $route.query.hash && submitSucceeded, 'md:w-2/3': !$route.query.hash && submitSucceeded }" class="w-full">
        <UserLoginButton />
      </div>
    </div>
  </div>
</template>
